import { apiService } from '@/services/ApiService.ts';
import { AuthenticationService } from '@/services/AuthenticationService.ts';
import { useAuthStore } from '@/stores/AuthStore.ts';
import { useUserInfoStore } from '@/stores/UserInfoStore.ts';
import { SubscriptionTier } from '@/types/SubscriptionTier.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { wsAuthLogIn } from '@/ws/requests/WsAuthLogIn.ts';
import { router, ROUTES } from '@/router.ts';
import { fetchAiModelsAction } from '@/actions/app/FetchAiModelsAction.ts';

/**
 * @throws {Error} On API error response
 */
export const logInTransferTokenAction = async (token: string) => {
    const apiResponse = await apiService.getApi().authLoginTransferTokenV1({
        loginTransferTokenRequestDto: {
            token: token,
        },
    });

    const { refreshToken, accessTokenExpiresIn, fingerprintHash, accessToken } =
        apiResponse.tokenData;

    AuthenticationService.instance.storeTokenData(
        accessToken,
        refreshToken,
        fingerprintHash,
        accessTokenExpiresIn,
    );

    const authStore = useAuthStore();
    authStore.isLoggedIn = true;

    const { creditsRemaining, username: userUsername, subscriptionTier } = apiResponse.userData;

    const userInfoStore = useUserInfoStore();
    userInfoStore.username = userUsername;
    userInfoStore.creditsRemaining = creditsRemaining;
    userInfoStore.subscriptionTier = subscriptionTier as SubscriptionTier;

    const settingsStore = useSettingsStore();
    settingsStore.rememberedUsername = userUsername;

    // Forcefully end onboarding
    settingsStore.isOnboarding = false;

    const sessionStore = useSessionStore();
    wsAuthLogIn(accessToken, !sessionStore.isInsideWebView);

    await fetchAiModelsAction();

    // Redirect if URL provided
    if (apiResponse.redirectUrl === null) {
        await router.push(ROUTES.authLogin);

        return;
    }

    if (apiResponse.redirectUrl.startsWith('http')) {
        window.location.href = apiResponse.redirectUrl;
    } else {
        await router.push(apiResponse.redirectUrl);
    }
};
